import React from 'react'
import { BpButton } from '../../../shared/components/buttons/bp-button/BpButton'
import illustration from '../../../shared/assets/no-results-illustation.svg'
import { useAppliedFilters } from '../../context/applied-filters/AppliedFiltersProvider'

export const NoResultsStub = () => {
  const { hasApplied, clearFilters } = useAppliedFilters()

  return (
    <div className={'flex justify-center'}>
      <div className={'flex w-[320px] flex-col items-center gap-[16px]'}>
        <img src={illustration} />
        <h2 className={'text-center text-[24px]'}>No results match the selected filters</h2>
        {hasApplied && (
          <BpButton className={'uppercase leading-[18px]'} size={'md'} onClick={clearFilters}>
            Clear filters
          </BpButton>
        )}
      </div>
    </div>
  )
}
